'use client';

// TODO make the component take a childre or SelectItem or SelectItemGorup so we can use it more flexibly

import {
	Portal, Select, ListCollection,
} from '@chakra-ui/react';
import type { SelectRootProps } from '@chakra-ui/react';

export type SelectInputProps = {
	clearTrigger?: boolean
	placeholder?:  string
	collection: ListCollection<{
		label: string
		value: string
	}>
} & SelectRootProps;

export const SelectInput = ({
	clearTrigger = false,
	collection,
	multiple,
	placeholder = '',
	...selectRootProps
}: SelectInputProps) => {
	return (
		<Select.Root
			collection={collection}
			multiple={multiple}
			{...selectRootProps}
		>
			<Select.HiddenSelect />
			<Select.Control>
				<Select.Trigger>
					<Select.ValueText placeholder={placeholder} />
				</Select.Trigger>
				<Select.IndicatorGroup>
					{clearTrigger && <Select.ClearTrigger />}
					<Select.Indicator />
				</Select.IndicatorGroup>
			</Select.Control>
			<Portal>
				<Select.Positioner>
					<Select.Content>
						{collection?.items?.map(item => (
							<Select.Item item={item} key={item.value}>
								{item.label}
								<Select.ItemIndicator />
							</Select.Item>
						))}
					</Select.Content>
				</Select.Positioner>
			</Portal>
		</Select.Root>
	);
};
